module.exports = __webpack_public_path__ + "static/media/AD.6af62724.svg";